import createAsyncAction from 'shared/utils/createAsyncAction';
import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';

import { GET_CASE_DATA_FORM } from 'modules/appointmentInfo/services/getCaseDataForm';
import createAction from './';

export const FETCH_CASE_DATA_FORM = createAsyncAction(createAction('FETCH_CASE_DATA_FORM'));

export const fetchCaseDataForm = () => (dispatch, getState) => {
  dispatch({ type: FETCH_CASE_DATA_FORM.pending });

  const { appointmentId } = getState().appointmentInfo.currentAppointment;

  const apiCallParams = {
    query: GET_CASE_DATA_FORM,
    fetchPolicy: 'no-cache',
    variables: {
      appointmentId,
    },
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { getCaseDataForm } }) => {
      return dispatch({
        type: FETCH_CASE_DATA_FORM.success,
        payload: getCaseDataForm,
      });
    })
    .catch((err) => dispatch(errorAction(FETCH_CASE_DATA_FORM.failure, err)));
};
